import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Layers, MapPin, Sparkles } from 'lucide-react';

const STATS = [
  { icon: Layers, value: '5+', label: 'Projects shipped' },
  { icon: Code2, value: '20+', label: 'Technologies used' },
  { icon: Sparkles, value: 'MERN', label: 'Primary stack' },
  { icon: MapPin, value: 'DE', label: 'Bamberg, Germany' },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

const About = () => {
  return (
    <section id="about" className="relative py-20 sm:py-28 bg-ink-950 font-body overflow-hidden">
      <div className="absolute inset-0 bg-grain pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="section-eyebrow">About</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold font-display">
            <span className="text-gradient">Frontend polish, backend discipline</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.6 }}
            className="lg:col-span-3 glass glass-hover rounded-2xl p-8 sm:p-10 flex flex-col justify-center"
          >
            <p className="text-white/70 leading-relaxed text-base sm:text-lg">
              I'm a full-stack developer who cares as much about how an interface{' '}
              <em className="text-mint-300 not-italic">feels</em> as how the system behind it
              performs. I transform designs into real, responsive applications with React,
              Next.js, and Tailwind CSS — then wire them up to Node/Express APIs and
              MongoDB or PostgreSQL databases so they actually work at scale.
            </p>
            <p className="mt-5 text-white/50 leading-relaxed">
              Outside of client work, I'm usually experimenting with new UI patterns, contributing
              to side projects, or — as you probably noticed — building small interactive things
              just because they're fun to make.
            </p>
          </motion.div>

          <div className="lg:col-span-2 grid grid-cols-2 gap-4">
            {STATS.map((stat, i) => (
              <motion.div
                key={stat.label}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeUp}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="glass glass-hover rounded-2xl p-5 sm:p-6 flex flex-col justify-between"
              >
                <stat.icon className="w-5 h-5 text-mint-400 mb-4" />
                <div>
                  <div className="text-2xl sm:text-3xl font-display font-bold text-white">
                    {stat.value}
                  </div>
                  <div className="text-xs sm:text-sm text-white/40 mt-1">{stat.label}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
